/*
rtl-filters.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/filters/rtl-filters',['angular'], function(angular) {
    var mod = angular.module('rtlFiltersModule', []);

    var applicationLanguageRTLMappings = function(getLocaleService) {
        return function(text, rtlText) {
            return getLocaleService.isApplicationLanguageRTL() ? rtlText : text;
        };
    };

    /**
     * Filter that provides getting equivalent text when application to be displayed in Hebrew (patient login) or English (HP login)
     *
     * eg. Tooltips should be 'left' on Hebrew screens, but same should be 'right' on HP screens.
     */
    mod.filter('applicationLanguageRTLMappings', ['getLocaleService', applicationLanguageRTLMappings]);
});

